import { IInfinitePageParams } from 'services/types';

export interface ISettlementPeriodName {
  name: string;
  year: number;
}

export interface ISettlementPeriodName {
  name: string;
  year: number;
}

export interface IGetSettlementLabelInfiniteParams extends IInfinitePageParams {
  StartSettlementPeriodId?: string;
  EndSettlementPeriodId?: string;
}

export interface ISettlementResponse {
  id: string;
  labelId: string;
  labelName?: string;
  settlementNumber: string;
  startSettlementPeriodId: string;
  endSettlementPeriodId: string;
  startSettlementPeriodDate: string;
  endSettlementPeriodDate: string;
  fileId: string;
  filePath: string | null;
  netAmount: number;
  startSettlementPeriodName: ISettlementPeriodName | null;
  endSettlementPeriodName: ISettlementPeriodName | null;
}
export interface ISettlementLabelResponse extends ISettlementResponse {}

export interface ITotalPageCount {
  totalPageCount: number;
}

export interface IInfinitePageResponse<Item = {}> extends ITotalPageCount {
  items: Item[];
}

export interface IInfinitePageStatisticsResponse<Item = {}, Stats = {}>
  extends IInfinitePageResponse<Item> {
  statistics: Stats;
}

export interface ISettlementLabelStatistics {
  allNetAmount: number;
}

export interface IProvidersInfiniteResponse
  extends IInfinitePageResponse<ISettlementResponse> {}

export interface ISettlementLabelStatistics {
  allNetAmount: number;
}

export interface ISettlementLabelPageResponse
  extends IInfinitePageStatisticsResponse<
    ISettlementLabelResponse,
    ISettlementLabelStatistics
  > {}
export interface IStatementsSearch {
  startSettlementPeriodId?: string;
  endSettlementPeriodId?: string;
}

export interface settlementPeriodName {
  name: string;
  year: number;
}

export interface ISettlementParams {
  pageSize?: number;
  page?: number;
}

export enum SETTLEMENT_PERIOD_TYPE_ENUM {
  unknown = -1,
  Month = 1,
  Quarter = 2,
  HalfYear = 3,
  Year = 4,
}

export interface SettlementPeriodType {
  id: SETTLEMENT_PERIOD_TYPE_ENUM;
  name: string;
}

export interface IResponseSettlementPeriodsLightList {
  id: string;
  settlementPeriodName: settlementPeriodName;
  settlementPeriodType: SettlementPeriodType;
}

export interface IResponsSettlementPeriods {
  id: string;
  settlementPeriodName: settlementPeriodName;
  startDate: string;
  endDate: string;
  settlementPeriodType: SettlementPeriodType;
}

export interface ICreateSettlementOrder {
  settlementPeriodId: string;
}

export interface ISettlementOrderResponse {
  id: string;
  labelId: string;
  labelName: string;
  startSettlementPeriodId: string;
  endSettlementPeriodId: string;
  settlementOrderStatusId: SETTLEMENT_ORDER_STATUS;
  settlementDate: string;
  createdAt: string;
  editedAt: string;
  startSettlementPeriodName: ISettlementPeriodName;
  endSettlementPeriodName: ISettlementPeriodName;
}

export enum SETTLEMENT_ORDER_STATUS {
  waiting = 1,
  inProgress = 2,
  done = 3,
  error = 4,
  canceled = 5,
  request = 6,
  rejected = 7,
}
